import Vue from 'vue'
import Element from 'element-ui'
import App from './App'
import './api'
import router from './router'
import config from './config'
import 'normalize.css'
import 'animate.css'
import 'oocss-utils/utils.css'
import 'assets/css/element-theme/index.css'
import 'assets/css/element-custom/index.scss'
import 'assets/css/base.css'
import dm from 'kkt-domain'

// use
Vue.use(Element)
Vue.use(dm)

// mixin
Vue.mixin({
  computed: {
    $currentUser: () => config.currentUser,
    $domain: () => config.domain
  }
})

// Vue 实例
let app = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

// set
window.$app = app

export default app



// WEBPACK FOOTER //
// ./src/main.js